import React from "react";
import { useLang } from "../../context/LanguageContext";
import { ADDRESS, LICENSE } from "../../lib/constants";

export const Footer = () => {
  const { t, lang } = useLang();
  const year = new Date().getFullYear();

  return (
    <footer
      data-testid="site-footer"
      className="relative bg-stone-950 text-stone-400 pt-20 pb-10 border-t border-stone-800/50"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 pb-16 border-b border-stone-800/60">
          <div className="md:col-span-5">
            <div className="font-heading text-4xl text-stone-50">Annette Rooms</div>
            <div className="mt-3 text-xs uppercase tracking-[0.3em] text-stone-500">
              Bari Palese · Puglia · Italia
            </div>
            <p className="mt-6 text-sm font-light leading-relaxed max-w-sm">
              {t.footer.tagline}
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="text-[11px] uppercase tracking-[0.25em] text-stone-500 mb-4">
              {t.contact.address}
            </div>
            <div className="text-sm text-stone-300 leading-relaxed">{ADDRESS}</div>
          </div>

          <div className="md:col-span-4">
            <div className="text-[11px] uppercase tracking-[0.25em] text-stone-500 mb-4">
              {lang === "it" ? "Navigazione" : "Navigation"}
            </div>
            <div className="grid grid-cols-2 gap-x-4 gap-y-2 text-sm">
              {[
                { href: "#about", label: t.nav.about },
                { href: "#rooms", label: t.nav.rooms },
                { href: "#gallery", label: t.nav.gallery },
                { href: "#location", label: t.nav.location },
                { href: "#reviews", label: t.reviews.overline },
                { href: "#contact", label: t.nav.contact },
              ].map((l) => (
                <a
                  key={l.href}
                  href={l.href}
                  data-testid={`footer-${l.href.replace("#", "")}`}
                  className="text-stone-300 hover:text-amber-300 transition-colors"
                >
                  {l.label}
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-8 flex flex-col md:flex-row md:items-center md:justify-between gap-4 text-[11px] uppercase tracking-[0.2em] text-stone-500">
          <div>
            © {year} Annette Rooms · {t.footer.rights}
          </div>
          <div>
            {t.footer.license}: {LICENSE}
          </div>
          <div>
            {lang === "it" ? "Realizzato da" : "Made by"}{" "}
            <a
              href="https://yudoweb.com"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="credit-yudo"
              className="text-amber-400 hover:text-amber-300 transition-colors border-b border-amber-400/40 hover:border-amber-300"
            >
              Yudo srl
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};
